var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('img',{staticClass:"title-back",attrs:{"src":"https://dobaycdn.anasit.com/dashboard_images/title-back.png"}}),_c('img',{staticClass:"title-back-ani",attrs:{"src":"https://dobaycdn.anasit.com/dashboard_images/title-back-ani.png"}}),_c('div',{staticClass:"title-word"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }